import React from 'react';
import { SvgIcon } from '@mui/material';

const CollapseSidebar = function CollapseSidebar({
  size = 400,
  color = 'currentColor',
  style = {},
}) {
  return (
    <SvgIcon sx={{ width: 'unset', height: 'unset', ...style }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="9" y1="3" x2="9" y2="21" />
        <path d="M17 16l-4-4 4-4" />
      </svg>
    </SvgIcon>
  );
};
export default CollapseSidebar;
